import React, { useState } from "react";
import EditIcon from "../../assets/Icons/EditIcon";
import Popup from "../../components/popup/Popup";
import ContactDetailForm from "./ContactDetailForm";
import useLocations from "../../utils/dropdown-options/useLocations";
import ConfirmationPopup from "./ConfirmationPopup";
import DeleteIcon from "../../assets/Icons/DeleteIcon";
import { toast } from "sonner";
import { useAppDispatch } from "../../config/hooks";
import { deleteContactApi } from "../../slices/salesSlice";

const Contact = ({ data }) => {
  const dispatch=useAppDispatch()
  const [togglePopupContact, setTogglePopupContact] = useState(false);
  const contact = data;
  const {defaultLocation,defaultLocations}=useLocations();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  // const contact = {
  //   name: "Sarah Johnson",
  //   designation: "CEO",
  //   phone: "+1-234-567-8901",
  //   email: "sarah.johnson@abctech.com",
  //   isPrimary: true,
  // };

  //   const currentContact = contacts.find(
  //     (contact) => contact.name === selectedContact
  //   );

  const togglePopupContactHandler = () => {
    setTogglePopupContact(!togglePopupContact);
  };


  const handleDeleteContact = () => {
    

    dispatch(deleteContactApi({id:contact.id,clientId:contact.clientId}))
    
    toast.success("Contact successfully deleted")
  };

  return (
    <>
      <div className=" min-w-64 border text-sm border-gray-300 rounded-lg px-3 pb-2  bg-white">
        {/* Header */}

        <div >
          <div className="flex gap-5 items-center  justify-end py-2">
            <div
              onClick={togglePopupContactHandler}
              className=" cursor-pointer"
              >
              <EditIcon />
            </div>
            {!contact.isPrimary && <div
              onClick={() => setShowDeleteConfirm(true)}
              className=" cursor-pointer"
              >
              <DeleteIcon/>
            </div>}
          </div>
          <div className="mb-2 flex justify-between">
            <div>
              <span className="text-exgray-400">Name :</span>{" "}
              <span className="text-exgray-800 ">
                {contact.firstName} {contact.lastName}
              </span>
            </div>
            {contact.isPrimary && (
              <span className="bg-blue-100 text-blue-600 text-xs font-semibold ml-2 px-2 py-0.5 rounded-full ">
                Primary
              </span>
            )}
          </div>
          <div className="mb-1">
            <span className="text-exgray-400">Designation :</span>{" "}
            <span className="text-exgray-800 ">{contact.designation}</span>
          </div>
          <div className="mb-1">
            <span className="text-exgray-400">Phone No. :</span>{" "}
            <span className="text-exgray-800 ">{contact.phoneNumber}</span>
          </div>
          <div className="mb-1">
            <span className="text-exgray-400">Alternate Phone No. :</span>{" "}
            <span className="text-exgray-800 ">{contact.alternatePhoneNumber}</span>
          </div>
          <div className="mb-1">
            <span className="text-exgray-400">Email ID :</span>{" "}
            <span className="text-exgray-800 ">{contact.email}</span>
          </div>
          <div className="mb-1">
            <span className="text-exgray-400">Alternate Email ID :</span>{" "}
            <span className="text-exgray-800 ">{contact.alternateEmail}</span>
          </div>
          <div className="mb-1">
            <span className="text-exgray-400">Location :</span>{" "}
            <span className="text-exgray-800 ">{defaultLocation(contact.location)?.Name}</span>
          </div>
        </div>
      </div>

      <Popup
        visible={togglePopupContact}
        onClose={togglePopupContactHandler}
        outsideClickClose={false}
        isCloseButton={true}
        children={
          <ContactDetailForm
            togglePopupHandler={togglePopupContactHandler}
            isUpdate={true}
            initialData={data}
          />
        }
      />

      {/* <Popup
        visible={togglePopupContact}
        onClose={togglePopupContactHandler}
        children={
          <ContactDetailForm
            togglePopupHandler={togglePopupContactHandler}
            isUpdate={true}
            initialData={data}
          />
        }
      /> */}

      <ConfirmationPopup
        visible={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
        onConfirm={handleDeleteContact}
        message="Are you sure you want to delete this contact?"
      />
    </>
  );
};

export default Contact;
